import React from 'react';
export function Logo({
  className = ''
}: {
  className?: string;
}) {
  return <div className={`flex items-center gap-3 ${className}`} data-id="element-157">
      <div className="relative w-24 h-16 md:w-32 md:h-20 shrink-0" data-id="element-158">
        <img src="https://cdn.magicpatterns.com/uploads/8MnQYu8Mb6pz1egX359VT6/Baxter_Family_plumbing_Logo_transparent.png" alt="Baxter Family Plumbing logo" className="w-full h-full object-contain" data-id="element-159" />
      </div>
      <div className="flex flex-col" data-id="element-160">
        <span className="font-display text-xl md:text-2xl text-white leading-none tracking-wider uppercase" data-id="element-161">
          Baxter Family
        </span>
        <span className="text-[10px] md:text-xs text-accent font-bold tracking-[0.2em] uppercase" data-id="element-162">
          Plumbing
        </span>
      </div>
    </div>;
}